module.exports = __webpack_public_path__ + "static/media/ci.d7c363c5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ci.svg
// module id = 2063
// module chunks = 0